/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const getCandidateExportLogsFilterStatusSchema = z.enum(['completed', 'failed'])

export type GetCandidateExportLogsFilterStatusSchema = z.infer<typeof getCandidateExportLogsFilterStatusSchema>
